import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
              isScrolled || !isHome ? 'bg-primary-500' : 'bg-white/20 backdrop-blur-sm'
            }`}>
              <i className={`ri-play-circle-fill text-xl ${isScrolled || !isHome ? 'text-white' : 'text-white'}`}></i>
            </div>
            <span className={`font-heading font-bold text-lg whitespace-nowrap transition-colors ${
              isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}>
              国产视频大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname === '/' ? 'text-primary-500' : ''}`}
            >
              首页
            </Link>
            <Link
              to="/category/yingshiju"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname.startsWith('/category') ? 'text-primary-500' : ''}`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-primary-500 whitespace-nowrap ${
                isScrolled || !isHome ? 'text-foreground-700' : 'text-white/90'
              } ${location.pathname === '/about' ? 'text-primary-500' : ''}`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled || !isHome ? 'hover:bg-background-100 text-foreground-600' : 'hover:bg-white/10 text-white/80'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className={`w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled || !isHome ? 'hover:bg-background-100 text-foreground-600' : 'hover:bg-white/10 text-white/80'
            }`}>
              <i className="ri-user-line text-lg"></i>
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled || !isHome ? 'hover:bg-background-100 text-foreground-700' : 'hover:bg-white/10 text-white'
            }`}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                location.pathname === '/' ? 'bg-primary-50 text-primary-600' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/yingshiju"
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                location.pathname.startsWith('/category') ? 'bg-primary-50 text-primary-600' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                location.pathname === '/about' ? 'bg-primary-50 text-primary-600' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}